import { useEffect, useState } from 'react';
import { api } from '../api';

// Read through the backend: the browser has no chat-database sign-in (RTDB rules deny it),
// and the backend picks dev-chat or prod-chat from the env toggle.
export function useConversation(userId, partnerId) {
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [threadKey, setThreadKey] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (userId == null || partnerId == null) return undefined;
    let mounted = true;
    setLoading(true);
    setError(null);
    api.get('/conversation', { params: { userId, partnerId } })
      .then(({ data }) => {
        if (!mounted) return;
        setMessages(data.messages || []);
        setThreadKey(data.key);
      })
      .catch((err) => {
        if (mounted) setError(err.response?.data?.error || 'Failed to load conversation');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => { mounted = false; };
  }, [userId, partnerId]);

  return { loading, messages, threadKey, error };
}
